import { useMemo, useState } from "react";
import { BusinessCheckout } from "@ecologi/react-components/src/BusinessCheckout";
import { useStore } from "../../../store";
import { selectErrorMessageFromResult } from "../selectors";
import { useCreateSubscription, useUpdateSubscription } from "../hooks";
import { Head } from "../../../components";
import { onSubmitCheckoutForm } from "@ecologi/react-components/src/CheckoutForm/utils/on-submit-checkout-form";
import { hasQueryInitiated } from "@ecologi/shared";
import { isProduction } from "../../../lib/utils/is-production";
import { getPhoenixUrl } from "../../../lib/getPhoenixUrl";

export function BusinessPlansPage() {
  const isProductionEnv = isProduction();

  const { user, location, stripe } = useStore();

  const [createSubscriptionMutation, createSubscriptionResult] =
    useCreateSubscription();

  const [updateSubscriptionMutation, updateSubscriptionResult] =
    useUpdateSubscription();

  const hasCreationInitiated = hasQueryInitiated(createSubscriptionResult);

  // Passing 'isLoading' as true even when the create query has succeeded ensures the
  // form doesn't unlock in the brief moment between the mutation succeeding and the user
  // being sent to the thanks page
  const isLoading =
    createSubscriptionResult.isLoading ||
    createSubscriptionResult.isSuccess ||
    updateSubscriptionResult.isLoading;

  const isUpdateSubscription = Boolean(
    user && user.subscription && !hasCreationInitiated
  );

  const checkoutErrorMessage = useMemo(
    () => selectErrorMessageFromResult(createSubscriptionResult),
    [createSubscriptionResult]
  );

  return (
    <>
      <Head
        title={`${
          isUpdateSubscription ? "Update" : "Create"
        } your Climate Action Workforce`}
      />
      <BusinessCheckout
        user={user}
        location={location}
        updateSubscription={updateSubscriptionMutation}
        isLoading={isLoading}
        isUpdateSubscription={isUpdateSubscription}
        settingsPageUrl={`${getPhoenixUrl()}/climate-action-workforce`}
        renderCheckoutForm={(props) => (
          <BusinessCheckout.CheckoutForm
            {...props}
            errorMessage={checkoutErrorMessage}
            isLoading={isLoading}
            isProduction={isProductionEnv}
            location={location}
            onSubmit={onSubmitCheckoutForm}
            stripe={stripe}
            subscribeUser={createSubscriptionMutation}
          />
        )}
      />
    </>
  );
}
